import { render } from "./SearchWidgetCustomElement.vue?vue&type=template&id=fc6f483e&scoped=true"
import script from "./SearchWidgetCustomElement.vue?vue&type=script&lang=js"
export * from "./SearchWidgetCustomElement.vue?vue&type=script&lang=js"

import "./SearchWidgetCustomElement.vue?vue&type=style&index=0&id=fc6f483e&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1683735176/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc6f483e"]])

export default __exports__